<div class="filters-container view">
    @if (isLoading) {
        <div class="loading">
            <mat-spinner color="accent" diameter="40"></mat-spinner>
            <p>Loading import filters...</p>
        </div>
    }

    @if (error) {
        <div class="error-message">
            <mat-icon>error</mat-icon>
            <p>{{ error }}</p>
        </div>
    }

  <mat-card class="cardPlain">
    <mat-card-header>
      <div class="section-header d-flex flex-col gap-4">
        <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
        <h1 class="m-0 f-w-500">Imports</h1>
        <p class="m-0 help-text">Create and manage import filters for company imports into HubSpot.</p>
      </div>
      <span class="spacer"></span>
    </mat-card-header>

    <mat-card-content>
      <div class="filter-bar">
        <div class="filter-controls form-no-subscripts">
          <div class="status-select">
            <mat-form-field appearance="outline" class="w-100">
              <mat-icon matPrefix>filter_list</mat-icon>
              <mat-label>Filter</mat-label>
              <mat-select
                [value]="statusFilter"
                (valueChange)="onStatusSelectChange($event)"
                multiple
                [panelClass]="'webinars-status-panel'"
              >
                <mat-select-trigger>
                  <span class="select-trigger-pills">
                    @if (!statusFilter || statusFilter.length === 0) {
                      <span class="status-pill status-all filter-pill">All</span>
                    }
                      @if (statusFilter && statusFilter.length) {
                          @for (v of statusFilter; track v) {
                        <span [ngClass]="'status-' + v" class="status-pill filter-pill">
                          {{ statusMetaFor(v).label }}
                        </span>
                          }
                      }
                  </span>
                </mat-select-trigger>

                  @for (filter of statusFilters; track filter) {
                      <mat-option [value]="filter.value">
                    <span [ngClass]="'status-' + filter.value" class="status-pill">
                      {{ filter.label }}
                        <span>({{ statusCountFor(filter.value) }})</span>
                    </span>
                      </mat-option>
                  }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="search-field">
            <mat-form-field appearance="outline" class="w-100">
              <mat-icon matPrefix>search</mat-icon>
              <mat-label>Search</mat-label>
              <input matInput type="text" [value]="filterTerm" (input)="onSearch($event)" />
            </mat-form-field>
          </div>

          <div class="filter-actions">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              (click)="onRefreshClick()"
              [disabled]="isLoading"
              class="d-inline-flex align-items-center gap-6"
            >
              <mat-icon>refresh</mat-icon>
              Refresh
            </button>

            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="createNewFilter()"
              class="d-inline-flex align-items-center gap-6"
            >
              <mat-icon>add</mat-icon>
              Create filter
            </button>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table [dataSource]="dataSource" class="webinars-table" [class.is-empty]="!dataSource.data.length" mat-table>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let filter">
              <button
                type="button"
                class="table-row-action"
                [attr.aria-label]="'Edit filter ' + filter.name"
                (click)="$event.stopPropagation(); editFilter(filter)"
              >
                <span class="filter-name">{{ filter.name }}</span>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let filter">{{ filter.description }}</td>
          </ng-container>

          <ng-container matColumnDef="criteria">
            <th mat-header-cell *matHeaderCellDef>Criteria</th>
            <td mat-cell *matCellDef="let filter">
              <div class="criteria-summary">{{ getFilterCriteriaSummary(filter) }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="enabled">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let filter">
              <span class="status-pill" [ngClass]="filter.enabled ? 'status-enabled' : 'status-disabled'">
                <mat-icon>{{ filter.enabled ? 'check_circle' : 'pause_circle' }}</mat-icon>
                {{ filter.enabled ? 'Enabled' : 'Disabled' }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editFilter(row)"></tr>

          <ng-container matColumnDef="footer">
            <td
              mat-footer-cell
              *matFooterCellDef
              class="table-footer-cell"
              [attr.colspan]="displayedColumns.length"
            >
              <div class="table-footer-content">
                <div class="total-count">Total <span class="amount">{{ dataSource.data.length }}</span></div>
                <mat-paginator
                  [length]="dataSource.data.length"
                  [pageSize]="10"
                  [hidePageSize]="true"
                  [showFirstLastButtons]="true"
                ></mat-paginator>
              </div>
            </td>
          </ng-container>

          <tr mat-footer-row *matFooterRowDef="['footer']" [hidden]="!dataSource.data.length"></tr>
        </table>
      </div>

        @if (!isLoading && !dataSource.data.length) {
            <div aria-live="polite" class="empty-state" role="region">
                <h3 class="title">{{ hasActiveFilters ? 'No results' : 'No import filters yet' }}</h3>
                <p class="description">
                    {{
            hasActiveFilters
                ? 'Try adjusting or clearing your filters to see more import filters.'
                : 'Get started by creating your first import filter.'
                    }}
                </p>
                <div class="actions">
                    <button (click)="createNewFilter()" color="primary" mat-flat-button type="button">Create filter
                    </button>
                    @if (hasActiveFilters) {
                        <button
                                (click)="clearFilters()"
                                color="primary"
                                mat-stroked-button
                                type="button"
                        >
                            Clear filters
                        </button>
                    }
                </div>
            </div>
        }
    </mat-card-content>
  </mat-card>
</div>
